/** Drawn first, in this order, because most contacts are one of these; the rest follow in catalog order. */
const LEADING_GROUP_CODES = ['trades_services', 'property_professionals'];

const leadingRank = (code: string) => {
	const index = LEADING_GROUP_CODES.indexOf(code);
	return index === -1 ? LEADING_GROUP_CODES.length : index;
};

/** The catalog's groups in the order every service picker offers them. Returns a new array. */
export const orderRoleGroups = <Group extends { code: string }>(groups: readonly Group[]): Group[] =>
	[...groups].sort((left, right) => leadingRank(left.code) - leadingRank(right.code));
